import { render, staticRenderFns } from "./AnswerNapPopup.vue?vue&type=template&id=58022272&scoped=true"
import script from "./AnswerNapPopup.vue?vue&type=script&lang=js"
export * from "./AnswerNapPopup.vue?vue&type=script&lang=js"
import style0 from "./AnswerNapPopup.vue?vue&type=style&index=0&id=58022272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58022272",
  null
  
)

export default component.exports